import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowUpRight } from 'lucide-react';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { id: 'about', label: 'About' },
    { id: 'services', label: 'Services' },
    { id: 'how-it-works', label: 'How It Works' },
    { id: 'faq', label: 'FAQ' },
    { id: 'requirements', label: 'Requirements' },
  ];

  return (
    <header className={`sticky top-0 z-50 transition-all duration-500 ${scrolled ? 'bg-[#040F2D]/95 backdrop-blur-xl border-b border-white/10' : 'bg-[#040F2D] border-b border-white/5'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-4 flex justify-between items-center">
        <a href="/" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_563d6243-6438-4f0a-a4a2-1ab5ee42a002/artifacts/gk86wjkd_Logo_Goldcif-removebg-preview.png"
            alt="GOLDCIF"
            className="h-9 w-auto"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-white/70 font-institutional-body">
          {navItems.map((it) => (
            <button
              key={it.id}
              onClick={() => scrollToSection(it.id)}
              className="hover:text-white transition-colors"
            >
              {it.label}
            </button>
          ))}
          <button
            onClick={() => scrollToSection('application')}
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#020817] font-medium text-sm px-5 py-2.5 hover:bg-[#F3E5AB] transition-colors font-institutional-body"
            data-testid="header-apply-btn"
          >
            Apply Now <ArrowUpRight className="w-4 h-4" />
          </button>
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#040F2D] border-t border-white/10">
          <div className="px-6 py-4 space-y-3 font-institutional-body">
            {navItems.map((it) => (
              <button
                key={it.id}
                onClick={() => scrollToSection(it.id)}
                className="block w-full text-left py-2 text-white/70 hover:text-white transition-colors"
              >
                {it.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('application')}
              className="w-full mt-4 bg-[#D4AF37] text-[#020817] font-medium py-3 hover:bg-[#F3E5AB] transition-colors flex items-center justify-center gap-2"
            >
              Apply Now <ArrowUpRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
